import {
    DIC
} from '@/const/dic'
import {
    validateCapitalUnderline,
} from '@/util/validate'
import {
    formatterTime
} from '@/util/util'



const validateCode = (rule, value, callback) => {
    if (!validateCapitalUnderline(value) || value.length > 50 || value.length < 1) {
        callback(new Error('模板编码为1-50位大写字母加下划线组成'))
    } else {
        callback();
    }
}
export const messageTipModuleOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    border: true,
    expand: false,
    stripe: false,
    showHeader: true,
    // align: 'center',
    index: false,
    selection: true,
    menu: true,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    viewBtn: true,
    menuWidth: '300',
    defaultSort: {
        prop: 'createTime',
        order: 'descending'
    },
    column: [{
            label: "模板类型",
            prop: "templateType",
            placeholder: "请选择模板类型",
            type: 'select',
            hide: true,
            dicData: DIC.SMS_TEMPLATE_TYPE,
            addVisdiplay: false,
            editVisdiplay: false,
            viewVisdiplay: false,
            // rules: [
            //     {
            //         required: true,
            //         trigger: "blur",
            //         message: "请选择模板类型",
            //     }
            // ],
            formsolt: true,
        }, {
            label: "模板名称",
            prop: "templateName",
            search: true,
            span: 13,
            type: "input",
            // rules: [{
            //     required: true,
            //     trigger: "blur",
            //     message: "请输入模板名称",
            // }]

        },
        {
            label: "模板编码",
            prop: "templateCode",
            placeholder: "请输入模板编码",
            search: true,
            span: 13,
            type: 'input',
            // rules: [{
            //     trigger: "blur",
            //     validator: validateCode
            // }]
        },


        {
            label: "模板用途",
            prop: "useType",
            placeholder: "请选择模板用途",
            type: 'select',
            dicData: DIC.SMS_TEMPLATE_USE_TYPE,
            addVisdiplay: false,
            editVisdiplay: false,
            viewVisdiplay: false,
            hide: true,
            // rules: [{
            //     required: true,
            //     trigger: "blur",
            //     message: "请选择模板用途",
            // }]
        },
        {
            label: "模板内容",
            prop: "content",
            type: 'textarea',
            placeholder: "请输入您的模版内容，如：尊敬的${name}，您好，由${business}为您提供的${type}服务已被接单。",
            // rules: [{
            //     required: true,
            //     trigger: "blur",
            //     message: "请输入短信模板内容",
            //     max: 255
            // }]
        },

        {
            label: "审核未通过原因",
            prop: "passRemarks",
            type: 'textarea',
            addVisdiplay: false,
            editVisdiplay: false,
        },

        {
            label: "模板状态",
            prop: "templateStatus",
            dicData: DIC.SMS_TEMPLATE_STATUS,
            type: "select",
            search: true,
            addVisdiplay: false,
            editVisdiplay: false,
        },
        {
            label: "验证码规则",
            prop: "rule",
            solt: true,
            formsolt: true,
            hide: true,
            addVisdiplay: false,
            editVisdiplay: false,
            viewVisdiplay: false,
        },
        {
            label: "创建人",
            prop: "createBy",
            type: "input",
            search: true,
            addVisdiplay: false,
            editVisdiplay: false,
            viewVisdiplay: false,
        },
        {
            label: "创建时间",
            prop: "createTime",
            type: "datetime",
            sortable: true,
            format: "yyyy-MM-dd HH:mm:ss",
            addVisdiplay: false,
            editVisdiplay: false,
            viewVisdiplay: false,
        },

        {
            label: "状态",
            prop: "status",
            type: "radio",
            addVisdiplay: false,
            editVisdiplay: false,
            viewVisdiplay: false,
            hide: true,
            dicData: DIC.STATE
        },
        {
            label: "更新时间",
            prop: "updateTime",
            type: "datetime",
            format: "yyyy-MM-dd HH:mm:ss",
            hide: true,
            addVisdiplay: false,
            editVisdiplay: false,
            viewVisdiplay: false,
        },
        {
            label: "更新人",
            prop: "updateBy",
            type: "input",
            hide: true,
            addVisdiplay: false,
            editVisdiplay: false,
            viewVisdiplay: false,
        },
        {
            label: "是否删除",
            prop: "deleteFlag",
            type: "radio",
            hide: true,
            addVisdiplay: false,
            editVisdiplay: false,
            viewVisdiplay: false,
            dicData: DIC.DELETE_FLAG
        },
        {
            label: "备注",
            prop: "remarks",
            type: "textarea",
            addVisdiplay: false,
            editVisdiplay: false,
            viewVisdiplay: false,
            hide: true,
            span: 24,
            max: 255
        },
        {
            label: "创建时间",
            prop: "startDate_endDate",
            type: "datetimerange",
            valueFormat: "timestamp",
            span: 24,
            clearable: true,
            hide: true,
            search: true,
            viewVisdiplay: false,
            addVisdiplay: false,
            editVisdiplay: false,
            formatter: function (row, value, label, column) {
                return formatterTime(row.startTime) + '至' + formatterTime(row.endTime)
            }
        }
    ]
};